module.exports = __webpack_public_path__ + "img/garvis.7ec3c9a6.png";